import { ref } from 'vue';
import { fuzzyQueryUser } from '@/api/user/index';
import type { UserItem } from '@/api/user/index.d';

export function useFuzzyFetchDesigner() {
  const designerList = ref<UserItem[]>([]);
  const fetchDesignerLoading = ref(false);

  const fetchDesignerList = async (userName: string) => {
    userName = userName.trim();
    try {
      if (!userName) {
        designerList.value = [];
        return;
      }
      fetchDesignerLoading.value = true;
      const { data } = await fuzzyQueryUser({
        keyword: userName,
      });
      designerList.value = data || [];
    } catch (error: any) {
      console.error(error);
      if (error && error.isCancel) {
        setTimeout(() => {
          fetchDesignerLoading.value = true;
        });
      }
    } finally {
      fetchDesignerLoading.value = false;
    }
  };

  return {
    fetchDesignerLoading,
    designerList,
    fetchDesignerList,
  };
}
